// @flow weak
/*
 * Make sure an element exists. Otherwise, create it.
 */

import PropTypes from 'prop-types';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

const EnsureElement = createReactClass({
  displayName: 'EnsureElement',
  hasElement: false,

  propTypes: {
    selector: PropTypes.string.isRequired,
    onMissing: PropTypes.func.isRequired,
    children: PropTypes.any,
  },

  UNSAFE_componentWillMount() {
    const { props } = this;
    if (document.querySelectorAll(props.selector).length === 0) {
      props.onMissing();
      this.hasElement = document.querySelectorAll(props.selector).length > 0;
    } else {
      this.hasElement = true;
    }
  },

  render() {
    return this.hasElement ? this.props.children : null;
  },
});

export default EnsureElement;
